import { createActions } from 'redux-actions'

const { catchApiError, clearApiError } = createActions({
  CATCH_API_ERROR: payload => payload,
  CLEAR_API_ERROR: () => {}
})

export { catchApiError, clearApiError }
